import {StyleSheet} from "aphrodite";
import * as React from "react";
import arePropsEqual from "react-fast-compare";

import {View} from "@khanacademy/wonder-blocks-core";
import type {
    ChatInputMetadata,
    HideChatOptions,
    ImageInput,
} from "@khan/guide-types";

import type {ChatInputComponent} from "./chat-input/chat-input.tsx";
import {ChatMainContent} from "./chat-main-content.tsx";
import {Preferences} from "./guide-preferences/preferences.tsx";

interface Props {
    conversationRecordedNotice?: React.ReactNode;
    forceHideChatOptions?: HideChatOptions;
    disclaimerNotice?: React.ReactNode;
    expanded?: boolean;
    onClosePreferences?: () => void;
    onMessageSend: (
        message: string,
        imagesAttached: Array<ImageInput>,
        metadata: ChatInputMetadata,
    ) => unknown;
    showPreferences?: boolean;
    skipSpeechOnboarding?: boolean;
    ChatInputComponent?: ChatInputComponent;
}

const GuideConversation = ({
    conversationRecordedNotice,
    forceHideChatOptions,
    disclaimerNotice,
    expanded,
    onClosePreferences,
    onMessageSend,
    showPreferences,
    skipSpeechOnboarding,
    ChatInputComponent,
}: Props): React.ReactElement => {
    return (
        <View style={styles.conversationWrapper}>
            {disclaimerNotice}
            {showPreferences ? (
                <Preferences onClose={onClosePreferences} />
            ) : (
                <ChatMainContent
                    forceHideChatOptions={forceHideChatOptions}
                    conversationRecordedNotice={conversationRecordedNotice}
                    expanded={expanded}
                    onMessageSend={onMessageSend}
                    skipSpeechOnboarding={skipSpeechOnboarding}
                    ChatInputComponent={ChatInputComponent}
                />
            )}
        </View>
    );
};

const MemoizedGuideConversation = React.memo(GuideConversation, arePropsEqual);

export {MemoizedGuideConversation as GuideConversation};

const styles = StyleSheet.create({
    conversationWrapper: {
        height: "100%",
        // max-height property seems to be necessary to ensure iOS scroll behavior.
        maxHeight: "100%",
        width: "100%",
        overflowY: "hidden",
    },
});
